import { logger } from './logger';

/**
 * Returns the API base URL.
 * - If REACT_APP_BACKEND_URL is set and matches the current origin: uses it.
 * - Otherwise (e.g. on medipocket.fr): uses same-origin (empty string)
 *   so cookies work without cross-domain issues.
 */
function getApiUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (!envUrl) return '';
  try {
    if (new URL(envUrl).origin === window.location.origin) return envUrl;
  } catch (err) {
    logger.warn('API URL parse failed, falling back to same-origin:', err?.message);
  }
  return '';
}

export const API_URL = getApiUrl();
